// src/pages/Login.jsx
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/msalConfig";

export default function Login() {
  const { instance, inProgress } = useMsal();
  const [ssoAttempted, setSsoAttempted] = useState(false);

  useEffect(() => {
    if (ssoAttempted || inProgress !== "none") return;
    setSsoAttempted(true);

    const cachedAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];
    if (cachedAccount) {
      instance.setActiveAccount(cachedAccount);
      return;
    }

    instance.ssoSilent(loginRequest)
      .then(response => {
        if (response?.account) instance.setActiveAccount(response.account);
      })
      .catch(() => {
        // No existing Microsoft browser session was available; the user can sign in manually.
      });
  }, [instance, inProgress, ssoAttempted]);

  return (
    <div style={{ display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
      <div style={{ textAlign: "center", maxWidth: 360 }}>
        <div style={{ fontFamily: "var(--font-head)", fontSize: 26, fontWeight: 800, letterSpacing: "-0.03em", color: "var(--text)", marginBottom: 6 }}>
          Christway <span style={{ color: "var(--accent)" }}>Devices</span>
        </div>
        <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 40, textTransform: "uppercase", letterSpacing: "0.08em" }}>
          Lifecycle Dashboard
        </div>
        <button
          onClick={() => instance.loginRedirect(loginRequest)}
          disabled={inProgress !== "none"}
          style={{ background: "var(--accent)", color: "#fff", border: "none", padding: "12px 32px", borderRadius: 8, cursor: "pointer", fontSize: 14, fontWeight: 600, letterSpacing: "0.01em" }}
        >
          {inProgress === "none" ? "Sign in with Microsoft" : "Checking Microsoft session…"}
        </button>
      </div>
    </div>
  );
}
